<div class="box-wrapper box-info">
	<div class="box-content-header">
		<div class="row p-1">
			<div class="col">
				<mat-card-title>
					<i class="fa-solid fa-circle-info"></i>
					<span>Informații adiționale</span>
				</mat-card-title>
			</div>
			<div class="col d-flex justify-content-end" *ngIf="has_checkbox_details || has_form_data">
				<div>
					<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onInfoChange($event)"
						[value]="selectedInfoStatus">
						<mat-button-toggle value="info">Informații</mat-button-toggle>
						<mat-button-toggle value="bife" *ngIf="has_checkbox_details">Bife</mat-button-toggle>
						<mat-button-toggle value="formular" *ngIf="has_form_data">Formular complet</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</div>
		</div>
	</div>
	<div class="box-content-body">
		<div class="form-groups-list" *ngIf="selectedInfoStatus === 'formular'">
			<span *ngFor="let group of cerere?.formData" class="form-group-chip"
				[class.active]="group === selectedFormGroup" [class.disabled]="!group.fields?.length"
				(click)="group.fields?.length && selectFormGroup(group)">
				{{ group.label }}
			</span>
		</div>

		<table class="table table-striped table-wrapper-box">
			<tbody *ngIf="selectedInfoStatus === 'info'">
				<tr *ngFor="let field of currentFormFields">
					<td *ngIf="!field.isCheckboxField" width="60%"><strong>{{ field.label }}</strong></td>
					<td *ngIf="!field.isCheckboxField" width="40%">
						<ng-container [ngSwitch]="field.type">
							<!-- Boolean Type -->
							<ng-container *ngSwitchCase="'boolean'">
								{{ cerere?.informatii[field.value] ? 'Da' : 'Nu' }}
							</ng-container>

							<!-- Date Type -->
							<ng-container *ngSwitchCase="'date'">
								{{ cerere?.informatii[field.value] | date:'dd-MM-yyyy HH:mm' }}
							</ng-container>

							<ng-container *ngSwitchDefault>
								{{ cerere?.informatii[field.value] ? cerere?.informatii[field.value] : 'N/A' }}
							</ng-container>
						</ng-container>
						<span *ngIf="field.value == 'numar_cadastral'" class="text-warning pointer" (click)="updateInformatiiCerere(field)"><i class="fa fa-pencil"></i></span>
                        <span *ngIf="field.value == 'motivatie' && permissionsService.hasPermission('urbanism-module.solicitari.view.update-scop')" class="text-warning pointer" (click)="updateInformatiiCerere(field)"><i class="fa fa-pencil"></i></span>
					</td>
				</tr>
			</tbody>

			<tbody *ngIf="selectedInfoStatus === 'bife'">
				<tr *ngFor="let field of preparedCheckboxDetails">
					<td width="85%"><strong>{{ field.label }}</strong></td>
					<td width="15%">
						<ng-container [ngSwitch]="field.type">
							<!-- Boolean Type -->
							<ng-container *ngSwitchCase="'boolean'">
								{{ field.value ? 'Da' : 'Nu' }}
							</ng-container>

							<!-- Date Type -->
							<ng-container *ngSwitchCase="'date'">
								{{ field.value }}
							</ng-container>

							<ng-container *ngSwitchDefault>
								{{ field.value ? field.value : 'N/A' }}
							</ng-container>
						</ng-container>
					</td>
				</tr>
			</tbody>

			<tbody *ngIf="selectedInfoStatus === 'formular' && selectedFormGroup">
				<tr *ngFor="let field of selectedFormGroup.fields">
					<td width="60%">{{ field.label }}</td>
					<td width="40%">{{ formatFormDataValue(field.value) }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>